﻿import "./Home.scss";
import logo from "../../assets/logo.svg";
import { NavBar } from "../../shared/components";
import { ErrorContainer } from "../../shared/pages/ErrorContainer";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { RequestAssistance } from "../actions/request-assistance";

function Home() {
    const pageError = useSelector((state: RootState) => state.app.errors.page);

    return (
        <>
            <NavBar title="Home" breadcrumbStack={[{ title: "Home" }]} actions={<><RequestAssistance /></>} />

            <ErrorContainer error={pageError}>
                <div className="home-content">
                    <img id="home-logo" src={logo} alt="The Qerent logo" className="logo" />
                    <span id="home-header-1">Welcome to Qerent!</span>
                    <span id="home-header-2">Please use the navigation menu (on the left) to select a page to view.</span>
                </div>
            </ErrorContainer>
        </>
    );
}

export default Home;